module.exports = __webpack_public_path__ + "static/media/kuro_game_ill.52d7fee1.svg";